import { useEffect, useState } from "react";

// Seconds left until `at` (timestamp), ticking once a second; null when no target.
export const useCountdown = (at) => {
  const calc = () => (at ? Math.max(0, Math.ceil((at - Date.now()) / 1000)) : null);
  const [left, setLeft] = useState(calc);
  useEffect(() => {
    setLeft(calc());
    if (!at) return;
    const t = setInterval(() => setLeft(calc()), 1000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [at]);
  return left;
};

export const fmtCountdown = (s) => (s === null ? "" : s >= 60 ? `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, "0")}s` : `${s}s`);
